import { useTranslation } from 'react-i18next'

import { EntityPhaseList, EntityPhaseLoading } from '../../Entity'
import { useDocFlowContext } from '../DocFlow.hooks'

import {
  getDocFlowPhaseStatusText,
  getDocFlowPhaseTooltipAdditionalText,
  getPreparedPhases,
  isDisabledDocFlowPhase,
} from './DocFlowProfileHeaderContent.utils'

import * as styles from './DocFlowProfileHeaderContent.module.css'

function DocFlowProfileHeaderContent() {
  const { t } = useTranslation()

  const { activePhase, docFlow, docFlowInitiated, setActivePhase } =
    useDocFlowContext()

  const phases = getPreparedPhases(docFlow?.phase, t)

  return !docFlowInitiated ? (
    <EntityPhaseLoading />
  ) : (
    <EntityPhaseList
      className={styles.phases}
      getPhaseStatusText={getDocFlowPhaseStatusText}
      getTooltipAdditionalText={getDocFlowPhaseTooltipAdditionalText}
      isDisabledItem={isDisabledDocFlowPhase}
      items={phases}
      phaseItemClassName={styles.phase}
      showTooltip={!docFlow?.archived}
      value={activePhase}
      onClick={setActivePhase}
    />
  )
}

export default DocFlowProfileHeaderContent
